// (function () {
//   if (!document.body.classList.contains("ups-auction-collection")) return;

//   const MAX_CONCURRENT = 4;         // faster than iframes
//   const queue = [];
//   let active = 0;
//   const cache = new Map();          // url -> {endMs, currentBid, bids}

//   const cards = () => Array.from(document.querySelectorAll("[data-ups-auction-card-info][data-ups-bid-url]"));

//   // function parseAuctionFromHTML(html) {
//   //   const doc = new DOMParser().parseFromString(html, "text/html");
//   //   const app = doc.querySelector("#auction_app");
//   //   if (!app) return null;

//   //   const rows = Array.from(app.querySelectorAll("tr"));
//   //   let bids = "0", currentBid = null, endText = null;

//   //   for (const tr of rows) {
//   //     const tds = tr.querySelectorAll("td");
//   //     if (tds.length < 2) continue;
//   //     const k = (tds[0].innerText || "").trim().toLowerCase();
//   //     const v = (tds[1].innerText || "").trim();

//   //     if (k.includes("number of bids")) bids = v;
//   //     if (k.includes("current bid")) currentBid = v;
//   //     if (k.includes("end time")) endText = v;
//   //   }
//   //   if (!currentBid || !endText) return null;

//   //   const d1 = new Date(endText);
//   //   const d2 = new Date(endText.replace(",", ""));
//   //   const endDate = !isNaN(d1.getTime()) ? d1 : (!isNaN(d2.getTime()) ? d2 : null);
//   //   if (!endDate) return null;

//   //   return { bids, currentBid, endMs: endDate.getTime() };
//   // }

//   function parseAuctionFromHTML(html) {
//     const doc = new DOMParser().parseFromString(html, "text/html");

//     // 1) Old structure (if it ever exists)
//     const app = doc.querySelector("#auction_app");
//     if (app) {
//       const rows = Array.from(app.querySelectorAll("tr"));
//       let bids = "0", currentBid = null, endText = null;

//       for (const tr of rows) {
//         const tds = tr.querySelectorAll("td");
//         if (tds.length < 2) continue;
//         const k = (tds[0].innerText || "").trim().toLowerCase();
//         const v = (tds[1].innerText || "").trim();
//         if (k.includes("number of bids")) bids = v;
//         if (k.includes("current bid")) currentBid = v;
//         if (k.includes("end time")) endText = v;
//       }

//       if (!currentBid || !endText) return null;
//       const endDate = new Date(endText.replace(",", ""));
//       if (isNaN(endDate.getTime())) return null;
//       return { bids, currentBid, endMs: endDate.getTime() };
//     }

//     // 2) Your current widget structure (CodeBlock)
//     const wrapper = doc.querySelector("#codeBlock-auction-widget-wrapper");
//     if (!wrapper) return null;

//     const bidsEl = wrapper.querySelector("#codeBlock-no-of-bids");
//     const bidEl  = wrapper.querySelector("#codeBlock-current-bid");

//     // Find "End time" value by scanning the list items
//     let endText = null;
//     for (const item of wrapper.querySelectorAll(".auction-details-list-item")) {
//       const t = (item.textContent || "").trim().replace(/\s+/g, " ");
//       if (t.toLowerCase().startsWith("end time")) {
//         endText = t.replace(/^end time\s*/i, "").trim();
//         break;
//       }
//     }

//     const currentBid = bidEl ? bidEl.textContent.trim() : null;
//     const bids = bidsEl ? bidsEl.textContent.trim() : "0";
//     if (!currentBid || !endText) return null;

//     const endDate = new Date(endText.replace(",", ""));
//     if (isNaN(endDate.getTime())) return null;

//     return { bids, currentBid, endMs: endDate.getTime() };
//   }

//   function formatTimeLeft(endMs) {
//     const ms = endMs - Date.now();
//     if (ms <= 0) return "Ended";
//     const s = Math.floor(ms / 1000);
//     const d = Math.floor(s / 86400);
//     const h = Math.floor((s % 86400) / 3600);
//     const m = Math.floor((s % 3600) / 60);
//     if (d > 0) return `${d}d ${h}h`;
//     if (h > 0) return `${h}h ${m}m`;
//     return `${m}m`;
//   }

//   function render(el, info) {
//     el.dataset.upsEnd = String(info.endMs);
//     el.innerHTML = `
//       <span class="ups-pill ups-pill--time">Time left: ${formatTimeLeft(info.endMs)}</span>
//       <span class="ups-pill ups-pill--bid">Current: ${info.currentBid} • Bids: ${info.bids}</span>
//     `;
//   }

//   function fetchInfo(url, cb) {
//     if (cache.has(url)) return cb(cache.get(url));

//     // fetch(url + (url.includes("?") ? "&" : "?") + "ups_card=1", { credentials: "same-origin" })
//     fetch(url, { credentials: "same-origin" })
//       .then(r => r.text())
//       .then(html => {
//         const parsed = parseAuctionFromHTML(html);
//         if (parsed) {
//           cache.set(url, parsed);
//           cb(parsed);
//         } else {
//           cb(null);
//         }
//       })
//       .catch(() => cb(null));
//   }

//   function runNext() {
//     while (active < MAX_CONCURRENT && queue.length) {
//       const { el, url } = queue.shift();
//       active++;

//       fetchInfo(url, (info) => {
//         if (info) render(el, info);
//         else el.innerHTML = `<span class="ups-pill">Tap Bid Now</span>`;
//         active--;
//         runNext();
//       });
//     }
//   }

//   // Build jobs
//   for (const el of cards()) {
//     const url = el.getAttribute("data-ups-bid-url");
//     if (!url) continue;
//     queue.push({ el, url });
//   }

//   runNext();

//   // Update time left every 30s
//   setInterval(() => {
//     for (const el of cards()) {
//       const endMs = parseInt(el.dataset.upsEnd || "", 10);
//       if (!endMs) continue;
//       const pill = el.querySelector(".ups-pill--time");
//       if (pill) pill.textContent = `Time left: ${formatTimeLeft(endMs)}`;
//     }
//   }, 30000);
// })();

(() => {
  const hasAuctionCards = () => !!document.querySelector("[data-ups-auction-card-info]");
  if (!document.body.classList.contains("ups-auction-collection") && !hasAuctionCards()) return;

  const LOG = (...a) => console.log("[UPS-AUCTION]", ...a);
  const WARN = (...a) => console.warn("[UPS-AUCTION]", ...a);

  const SHOP = "72271f-5c.myshopify.com";
  const CUSTOMER_ID = 0;
  const TYPE = "undefined";

  const MAX_CONCURRENT = 6;
  let active = 0;

  // key: `${auctionId}:${productId}:${variantId}`
  const cache = new Map();
  // key: product URL
  const htmlCache = new Map();

  const cards = () =>
    Array.from(document.querySelectorAll("[data-ups-auction-card-info][data-ups-product-id][data-ups-variant-id]"));

  function parseAuctionFromHTML(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");

    // 1) Old structure (if it ever exists)
    const app = doc.querySelector("#auction_app");
    if (app) {
      const rows = Array.from(app.querySelectorAll("tr"));
      let bids = "0", currentBid = null, endText = null;

      for (const tr of rows) {
        const tds = tr.querySelectorAll("td");
        if (tds.length < 2) continue;
        const k = (tds[0].innerText || "").trim().toLowerCase();
        const v = (tds[1].innerText || "").trim();
        if (k.includes("number of bids")) bids = v;
        if (k.includes("current bid")) currentBid = v;
        if (k.includes("end time")) endText = v;
      }

      if (!currentBid || !endText) return null;
      const endDate = new Date(endText.replace(",", ""));
      if (isNaN(endDate.getTime())) return null;
      return { bids, currentBid, endMs: endDate.getTime() };
    }

    // 2) Current widget structure (CodeBlock)
    const wrapper = doc.querySelector("#codeBlock-auction-widget-wrapper");
    if (!wrapper) return null;

    const bidsEl = wrapper.querySelector("#codeBlock-no-of-bids");
    const bidEl = wrapper.querySelector("#codeBlock-current-bid");

    let endText = null;
    for (const item of wrapper.querySelectorAll(".auction-details-list-item")) {
      const t = (item.textContent || "").trim().replace(/\s+/g, " ");
      if (t.toLowerCase().startsWith("end time")) {
        endText = t.replace(/^end time\s*/i, "").trim();
        break;
      }
    }

    const currentBid = bidEl ? bidEl.textContent.trim() : null;
    const bids = bidsEl ? bidsEl.textContent.trim() : "0";
    if (!currentBid || !endText) return null;

    const endDate = new Date(endText.replace(",", ""));
    if (isNaN(endDate.getTime())) return null;

    return { bids, currentBid, endMs: endDate.getTime() };
  }

  function fetchInfoFromProductPage(url) {
    if (!url) return Promise.resolve(null);
    if (htmlCache.has(url)) return Promise.resolve(htmlCache.get(url));

    return fetch(url, { credentials: "same-origin" })
      .then((r) => r.ok ? r.text() : Promise.reject(new Error(`HTTP ${r.status}`)))
      .then((html) => {
        const parsed = parseAuctionFromHTML(html);
        if (!parsed) return null;
        htmlCache.set(url, parsed);
        return parsed;
      })
      .catch(() => null);
  }

  function money(n) {
    // auction data uses numbers; show like $1.00
    const num = typeof n === "number" ? n : parseFloat(String(n).replace(/[^\d.]/g, ""));
    if (!isFinite(num)) return null;
    return `$${num.toFixed(2)}`;
  }

  function formatTimeLeft(endMs) {
    const ms = endMs - Date.now();
    if (ms <= 0) return "Ended";
    const s = Math.floor(ms / 1000);
    const d = Math.floor(s / 86400);
    const h = Math.floor((s % 86400) / 3600);
    const m = Math.floor((s % 3600) / 60);
    if (d > 0) return `${d}d ${h}h`;
    if (h > 0) return `${h}h ${m}m`;
    return `${m}m`;
  }

  function render(el, info) {
    el.dataset.upsEnd = String(info.endMs || "");
    el.innerHTML = `
      <span class="ups-pill ups-pill--time">Time left: ${formatTimeLeft(info.endMs)}</span>
      <span class="ups-pill ups-pill--bid">Current: ${info.currentBid} • Bids: ${info.bids}</span>
    `;
  }

  function renderFallback(el, msg = "Tap Bid Now") {
    el.innerHTML = `<span class="ups-pill">${msg}</span>`;
  }

  function tryGetAuctionsFromWindow() {
    // Some apps attach it directly
    if (Array.isArray(window.auctions)) return window.auctions;
    if (Array.isArray(window.AUCTIONS)) return window.AUCTIONS;
    return null;
  }

  function tryParseAuctionsFromScripts() {
    // scan inline scripts for: var auctions = [...]
    const scripts = Array.from(document.scripts || []);
    for (const s of scripts) {
      const t = s.textContent || "";
      if (!t.includes("var auctions") && !t.includes("auctions =")) continue;

      // attempt to capture JSON array assigned to auctions
      // matches: var auctions = [...];
      const m = t.match(/(?:var|let|const)\s+auctions\s*=\s*(\[[\s\S]*?\])\s*;?/);
      if (!m || !m[1]) continue;

      try {
        return JSON.parse(m[1]);
      } catch (e) {
        // sometimes the array is huge/truncated in a single script; keep scanning
      }
    }
    return null;
  }

  function buildAuctionIndex(auctionsArr) {
    // key by productId:variantId
    const idx = new Map();
    for (const a of auctionsArr || []) {
      const auctionId = a?.id;
      const endDateTime = a?.endDateTime;
      const startPrice = a?.startPrice;

      if (!auctionId || !endDateTime || !a?.products) continue;

      const endMs = Date.parse(endDateTime);
      if (!isFinite(endMs)) continue;

      for (const p of a.products) {
        const productId = p?.productId;
        const variantId = p?.variantId;
        if (!productId || !variantId) continue;
        idx.set(`${productId}:${variantId}`, {
          auctionId,
          endMs,
          startPrice
        });
      }
    }
    return idx;
  }

  function getAuctionIndex() {
    const fromWin = tryGetAuctionsFromWindow();
    const fromScripts = fromWin ? null : tryParseAuctionsFromScripts();
    const auctionsArr = fromWin || fromScripts;

    if (!auctionsArr) {
      WARN("Could not find `auctions` payload on this page. Add AuctionToday auctions bootstrap here or inject it into the collection template.");
      return null;
    }

    return buildAuctionIndex(auctionsArr);
  }

  const auctionIndex = getAuctionIndex();

  function lastBidUrl({ auctionId, productId, variantId }) {
    const qs = new URLSearchParams({
      shop: SHOP,
      type: TYPE,
      productId: String(productId),
      variantId: String(variantId),
      customerId: String(CUSTOMER_ID),
      auctionId: String(auctionId)
    });
    return `/apps/auction-today/customer-portal/api/auction-last-bid?${qs.toString()}`;
  }

  function parseCurrentBidFromLastBidJson(json, startPrice) {
    // Your sample response:
    // { auctionBiddings: [], numberOfBids: 0, ... }
    const bidsArr = Array.isArray(json?.auctionBiddings) ? json.auctionBiddings : [];
    const numberOfBids = typeof json?.numberOfBids === "number" ? json.numberOfBids : bidsArr.length;

    // Try to extract an amount if present
    let amount = null;
    for (let i = bidsArr.length - 1; i >= 0; i--) {
      const b = bidsArr[i];
      const candidate =
        b?.bidAmount ??
        b?.amount ??
        b?.bid ??
        b?.currentBid ??
        null;

      if (candidate != null) {
        amount = candidate;
        break;
      }
    }

    // If no bids, fall back to startPrice
    const current = amount != null ? money(amount) : money(startPrice);
    return { currentBid: current || "$0.00", bids: String(numberOfBids || 0) };
  }

  function fetchAndRenderForCard(el) {
    const productId = el.getAttribute("data-ups-product-id");
    const variantId = el.getAttribute("data-ups-variant-id");
    const bidUrl = el.getAttribute("data-ups-bid-url");

    const renderFromProductPage = (fallbackMessage) =>
      fetchInfoFromProductPage(bidUrl)
        .then((info) => {
          if (info) render(el, info);
          else renderFallback(el, fallbackMessage);
        });

    if (!auctionIndex || !productId || !variantId) {
      return renderFromProductPage("Tap Bid Now");
    }

    const key = `${productId}:${variantId}`;
    const meta = auctionIndex.get(key);
    if (!meta) {
      return renderFromProductPage("Tap Bid Now");
    }

    const cacheKey = `${meta.auctionId}:${productId}:${variantId}`;
    if (cache.has(cacheKey)) {
      const info = cache.get(cacheKey);
      render(el, info);
      return Promise.resolve();
    }

    const url = lastBidUrl({
      auctionId: meta.auctionId,
      productId,
      variantId
    });

    return fetch(url, {
      method: "GET",
      credentials: "include",
      headers: { "x-requested-with": "XMLHttpRequest" }
    })
      .then((r) => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
      .then((json) => {
        const { currentBid, bids } = parseCurrentBidFromLastBidJson(json, meta.startPrice);

        const info = {
          endMs: meta.endMs,
          currentBid,
          bids
        };

        cache.set(cacheKey, info);
        render(el, info);
      })
      .catch((e) => {
        WARN("last-bid fetch failed", { productId, variantId, auctionId: meta.auctionId, e });
        return renderFromProductPage("Tap Bid Now");
      });
  }

  const queue = [];
  function pump() {
    while (active < MAX_CONCURRENT && queue.length) {
      const el = queue.shift();
      active++;
      Promise.resolve()
        .then(() => fetchAndRenderForCard(el))
        .finally(() => {
          active--;
          pump();
        });
    }
  }

  const seen = new WeakSet();
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const el = entry.target;
        if (seen.has(el)) continue;
        seen.add(el);
        queue.push(el);
        pump();
        io.unobserve(el);
      }
    },
    { root: null, rootMargin: "600px 0px", threshold: 0.01 }
  );

  for (const el of cards()) {
    // start in a non-fallback state
    // (so "Tap Bid Now" only appears if we truly can't resolve)
    el.innerHTML = `<span class="ups-pill">Loading…</span>`;
    io.observe(el);
  }

  // Update time left every 30s (no network)
  setInterval(() => {
    for (const el of cards()) {
      const endMs = parseInt(el.dataset.upsEnd || "", 10);
      if (!endMs) continue;
      const pill = el.querySelector(".ups-pill--time");
      if (pill) pill.textContent = `Time left: ${formatTimeLeft(endMs)}`;
    }
  }, 30000);

  LOG("initialized", { cards: cards().length, hasAuctionIndex: !!auctionIndex });
})();
